import { Alert } from 'react-native';
import { mobileLog } from '../../logging';
import { createVriReadCache } from './vriReadCache';
export const VRI_PROFILES_CACHE_KEY = 'vri_scheduling_profiles_scoped';
export const VRI_SCHEDULE_CACHE_KEY = 'vri_scheduled_sessions_scoped';
const cache = createVriReadCache([VRI_PROFILES_CACHE_KEY, VRI_SCHEDULE_CACHE_KEY], 'vri_scheduling_cache');
export const readSchedulingCache = cache.read;
export const hydrateSchedulingCache = cache.hydrate;
export const saveSchedulingCache = cache.save;
export const clearSchedulingCaches = cache.clear;
/**
 * Cleanup cannot hold sign-out open; a failed device removal stays visible.
 *
 * @returns {void} Starts cleanup without delaying navigation.
 */
export function beginSchedulingCacheCleanup() {
    clearSchedulingCaches().then(ok => {
        if (!ok) {
            mobileLog('warn', 'vri_scheduling_cache_cleanup_failed', {});
            try {
                Alert.alert('Saved schedule cleanup incomplete', 'Reload Schedule.');
            }
            catch {
                mobileLog('warn', 'vri_scheduling_cache_cleanup_notice_failed', {});
            }
        }
    });
}
